var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-4" },
    [
      _c(
        "p",
        { staticClass: "block text-sm leading-5 text-gray-700 font-bold" },
        [_vm._v("\n        Join the waiting list\n    ")]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "text-sm text-gray-600" }, [
        _vm._v(
          "\n        This date is currently fully booked. If you want to be notified if space becomes available, please join the\n        waiting list below.\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "special-button",
        {
          attrs: { type: "button" },
          nativeOn: {
            click: function ($event) {
              $event.preventDefault()
              _vm.showWaitingListModal = true
            },
          },
        },
        [_vm._v("\n        Join the Waiting List\n    ")]
      ),
      _vm._v(" "),
      _c(
        "portal",
        { attrs: { to: "modal" } },
        [
          _vm.showWaitingListModal
            ? _c(
                "modal",
                [
                  _c("h2", [_vm._v("Join the Waiting List.")]),
                  _vm._v(" "),
                  !_vm.waitingListSuccess
                    ? [
                        _c("p", { staticClass: "text-gray-600 mb-6" }, [
                          _vm._v(
                            "\n                    Please add me to the waiting list for the " +
                              _vm._s(_vm.eventName) +
                              " event on the " +
                              _vm._s(_vm.eventDate) +
                              ".\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "form",
                          {
                            staticClass: "mt-2",
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.signUpToWaitingList.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "grid sm:grid-cols-2 gap-6" },
                              [
                                _c("form-input", {
                                  attrs: {
                                    label: "First Name",
                                    for: "waiting_list_first_name",
                                    id: "waiting_list_first_name",
                                    name: "waiting_list_first_name",
                                    required: true,
                                    error: _vm.getErrorFor("first_name"),
                                  },
                                  model: {
                                    value: _vm.form.first_name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "first_name", $$v)
                                    },
                                    expression: "form.first_name",
                                  },
                                }),
                                _vm._v(" "),
                                _c("form-input", {
                                  attrs: {
                                    label: "Last Name",
                                    for: "waiting_list_last_name",
                                    id: "waiting_list_last_name",
                                    name: "waiting_list_last_name",
                                    required: true,
                                    error: _vm.getErrorFor("last_name"),
                                  },
                                  model: {
                                    value: _vm.form.last_name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "last_name", $$v)
                                    },
                                    expression: "form.last_name",
                                  },
                                }),
                                _vm._v(" "),
                                _c("form-input", {
                                  attrs: {
                                    type: "email",
                                    label: "Email",
                                    for: "waiting_list_email",
                                    id: "waiting_list_email",
                                    name: "waiting_list_email",
                                    required: true,
                                    error: _vm.getErrorFor("email"),
                                  },
                                  model: {
                                    value: _vm.form.email,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "email", $$v)
                                    },
                                    expression: "form.email",
                                  },
                                }),
                                _vm._v(" "),
                                _c("form-input", {
                                  attrs: {
                                    label: "Phone",
                                    for: "waiting_list_phone",
                                    id: "waiting_list_phone",
                                    name: "waiting_list_phone",
                                    required: true,
                                    error: _vm.getErrorFor("phone"),
                                  },
                                  model: {
                                    value: _vm.form.phone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "phone", $$v)
                                    },
                                    expression: "form.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "grid sm:grid-cols-2 gap-6 mt-8" },
                              [
                                _c(
                                  "form-button",
                                  {
                                    staticClass: "sm:order-2",
                                    attrs: { type: "submit" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            Add Me\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "form-button",
                                  {
                                    staticClass: "sm:order-1",
                                    attrs: { colour: "white" },
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.cancelWaitingList.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            Cancel\n                        "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    : [
                        _c("p", { staticClass: "text-gray-600 mb-6" }, [
                          _vm._v(
                            "\n                    You have successfully been added to the waiting list for the " +
                              _vm._s(_vm.eventName) +
                              " event on the\n                    " +
                              _vm._s(_vm.eventDate) +
                              ".\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "grid gap-6 mt-8" },
                          [
                            _c(
                              "form-button",
                              {
                                staticClass: "sm:order-1",
                                attrs: { colour: "white" },
                                nativeOn: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.cancelWaitingList.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        Close\n                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }